import { Component, ErrorInfo } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { somethingWentWrongPageRoute } from 'src/routes/route-list';
import { FlexColumn } from 'src/components/layout';
import { Page } from './Page';
import { PageHeader } from './PageHeader';
import { PageContainerProps } from './types';

interface PageContainerState {
  hasError: boolean;
}

type Props = PageContainerProps & WithTranslation;

class PageContainerContent extends Component<Props, PageContainerState> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {}

  render() {
    const { t, type, title, children } = this.props;

    if (this.state.hasError) {
      return <Navigate to={somethingWentWrongPageRoute} />;
    }

    switch (type) {
      case 'auth-default': {
        return (
          <Page title={title}>
            <FlexColumn mt={this.props.withMarginTop ? 15 : 'inherit'}>
              <PageHeader variant={this.props.header.size} sx={{ my: 4 }}>
                {t(this.props.header.text)}
              </PageHeader>
              {children}
            </FlexColumn>
          </Page>
        );
      }
      case 'non-auth':
      case 'auth-custom':
      default: {
        return <Page title={title}>{children}</Page>;
      }
    }
  }
}

export const PageContainer = withTranslation()(PageContainerContent);
